import { render, staticRenderFns } from "./FeesStats.vue?vue&type=template&id=fa41f9be&scoped=true"
import script from "./FeesStats.vue?vue&type=script&lang=js"
export * from "./FeesStats.vue?vue&type=script&lang=js"
import style0 from "./FeesStats.vue?vue&type=style&index=0&id=fa41f9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa41f9be",
  null
  
)

export default component.exports